import { Component, OnInit } from '@angular/core';
// Activated Route
import { ActivatedRoute } from '@angular/router';
// Servicios
import { CategoriaInscripcionService, CongresosService, ActividadesService, CategoriaTrabajoService } from '../../services/services.index';

// Modelos
import { Congreso } from '../../models/congreso.model';
import { CategoriaInscripcion } from '../../models/categoriaInscripcion.model';
import { Actividad } from '../../models/actividad';
import { CategoriaTrabajo } from '../../models/categoriaTrabajo.model';

// SWAL
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;


@Component({
  selector: 'app-congresos-edit',
  templateUrl: './congresos-edit.component.html',
  styles: []
})
export class CongresosEditComponent implements OnInit {

  congreso: Congreso = new Congreso();
  fechaInicioCongreso: Date;
  fechaFinCongreso: Date;
  fechaInicioInscripcion: Date;
  fechaFinInscripcion: Date;
  fechaInicioTrabajos: Date;
  fechaFinTrabajos: Date;
  categoriasInscripcion: CategoriaInscripcion[];
  actividades: Actividad[];
  categoriasInscripcionSeleccionada: any = '';
  actividadSeleccionada: any = '';
  categoriasTrabajo: CategoriaTrabajo[] = [];

  loading: boolean = true;

  constructor(private activatedRoute: ActivatedRoute,
              public _congresosService: CongresosService,
              public _categoriaInscripcionService: CategoriaInscripcionService,
              public _actividadesService: ActividadesService,
              public _categoriaTrabajoService: CategoriaTrabajoService) { }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.params.subscribe( params => {
      let congresoId: any = params['id'];
      if ( congresoId !== 'new' ) {
        this._congresosService.getCongreso(congresoId).subscribe((data: any) => {
          this.congreso = data.congreso;
          this.loading = false;
          // Transformacion de fechas
          this.fechaInicioCongreso = new Date(this.congreso.fechaInicioCongreso);
          this.fechaFinCongreso = new Date(this.congreso.fechaFinCongreso);
          this.fechaInicioInscripcion = new Date(this.congreso.fechaInicioInscripcion);
          this.fechaFinInscripcion = new Date(this.congreso.fechaFinInscripcion);
          this.fechaInicioTrabajos = new Date(this.congreso.fechaInicioTrabajos);
          this.fechaFinTrabajos = new Date(this.congreso.fechaFinTrabajos);
          this.loading = true;
          // Lleno opciones de Categorias de Inscripcion (borro las que ya estan seleccionadas)
          this._categoriaInscripcionService.getAllCategoriasInscripcion().subscribe((resp: any) => {
            if (resp.categoriasInscripcion) {
              for (let categoria of this.congreso.categoriasInscripcion) {
                for (let i = 0; i < resp.categoriasInscripcion.length; i++) {
                  if (resp.categoriasInscripcion[i]._id === categoria.categoriaInscripcion._id) {
                    resp.categoriasInscripcion.splice(i, 1);
                    break;
                  }
                }
              }
              this.categoriasInscripcion = resp.categoriasInscripcion;
              this.loading = false;
            }
          });
          this.loading = true;
          // Lleno las opciones de Actividades (borro las que ya estan seleccionadas)
          this._actividadesService.getAllActividades().subscribe((resp: any) => {
            if (resp.actividades) {
              for (let actividad of this.congreso.actividades) {
                for (let i = 0; i < resp.actividades.length; i++) {
                  if (resp.actividades[i]._id === actividad.actividad._id) {
                    resp.actividades.splice(i, 1);
                    break;
                  }
                }
              }
              this.actividades = resp.actividades;
              this.loading = false;
            }
          });
        });
      } else {
        this.loading = false;
        // Lleno las opciones de Categorias de Inscripcion
        this._categoriaInscripcionService.getAllCategoriasInscripcion().subscribe((resp: any) => {
          this.congreso.categoriasInscripcion = [];
          this.categoriasInscripcion = resp.categoriasInscripcion;
        });
        // Lleno las opciones de Actividades
        this._actividadesService.getAllActividades().subscribe((resp: any) => {
          this.congreso.actividades = [];
          this.actividades = resp.actividades;
        });
      }

    });
  }

  guardarCongreso() {
    this.loading = true;
    if (this.fechaInicioCongreso) { this.congreso.fechaInicioCongreso = this.fechaInicioCongreso.getTime(); }
    if (this.fechaFinCongreso) { this.congreso.fechaFinCongreso = this.fechaFinCongreso.getTime(); }
    if (this.fechaInicioInscripcion) { this.congreso.fechaInicioInscripcion = this.fechaInicioInscripcion.getTime(); }
    if (this.fechaFinInscripcion) { this.congreso.fechaFinInscripcion = this.fechaFinInscripcion.getTime(); }
    if (this.fechaInicioTrabajos) { this.congreso.fechaInicioTrabajos = this.fechaInicioTrabajos.getTime(); }
    if (this.fechaFinTrabajos) { this.congreso.fechaFinTrabajos = this.fechaFinTrabajos.getTime(); }
    this._congresosService.guardarCongreso(this.congreso).subscribe((congreso: Congreso) => {
      if (congreso.categoriasInscripcion.length === 0 && congreso.actividades.length === 0) {
        this.congreso = congreso;
      }
      swal('Congreso Guardado', 'El congreso ' + congreso.titulo_es + ' fue guardado satisfactoriamente.', 'success');
      this.loading = false;
    });
  }

  getDate(timestamp: number) {
    return new Date(timestamp);
  }


  //// Categoria de inscripcion --> Metodos

  agregarCategoriaInscripcion() {
    for (let i = 0; i < this.categoriasInscripcion.length; i++) {
      if (this.categoriasInscripcion[i]._id === this.categoriasInscripcionSeleccionada) {
        this.congreso.categoriasInscripcion.push({categoriaInscripcion: JSON.parse(JSON.stringify(this.categoriasInscripcion[i]))});
        this.categoriasInscripcion.splice(i, 1);

        break;
      }
    }
  }

  deleteCategoriaInscripcion(i: number) {
    if (this.congreso.categoriasInscripcion[i]._id) {
      this._congresosService.deleteCategoriaInscripcion(this.congreso.categoriasInscripcion[i]._id).subscribe(resp => {
        swal('Categoria de Inscripcion Borrada',
              'Categoria de Inscripcion borrada correctamente. La modificación fue guardada.',
              'success');

        // Agrego categoria a las opciones
        this.categoriasInscripcion.push(JSON.parse(JSON.stringify(this.congreso.categoriasInscripcion[i].categoriaInscripcion)));
        // Borro categoria del congreso
        this.congreso.categoriasInscripcion.splice(i, 1);
      });
    } else {
      // Agrego categoria a las opciones
      this.categoriasInscripcion.push(JSON.parse(JSON.stringify(this.congreso.categoriasInscripcion[i].categoriaInscripcion)));
      // Borro categoria del congreso
      this.congreso.categoriasInscripcion.splice(i, 1);
    }

  }

  guardarCategoriaInscripcion(i: number) {
    this.loading = true;
    if (!this.congreso.categoriasInscripcion[i]._id) {
      this._congresosService.addCategoriaInscripcion(this.congreso.categoriasInscripcion[i], this.congreso._id).subscribe(resp => {
        swal('Categoria de Inscripcion Agregada',
              'Categoria de Inscripcion agregada correctamente. La modificación fue guardada.',
              'success');
              this.loading = false;
      });
    } else {
      // editar
      this._congresosService.editarCategoriaInscripcion(
        this.congreso.categoriasInscripcion[i]._id,
        this.congreso.categoriasInscripcion[i].precio,
        this.congreso.categoriasInscripcion[i].precio_usd
      ).subscribe(resp => {
        swal('Categoria de Inscripcion Editada',
              'Categoria de Inscripcion editada correctamente. La modificación fue guardada.',
              'success');
              this.loading = false;
      });
    }

  }

  // Fin Categorias de Inscripcion --> Metodos

  // Actividades --> Metodos

  agregarActividad() {
    for (let i = 0; i < this.actividades.length; i++) {
      if (this.actividades[i]._id === this.actividadSeleccionada) {
        this.congreso.actividades.push({actividad: JSON.parse(JSON.stringify(this.actividades[i]))});
        this.actividades.splice(i, 1);

        break;
      }
    }
  }

  deleteActividad(i: number) {
    if (this.congreso.actividades[i]._id) {
      this._congresosService.deleteActividad(this.congreso.actividades[i]._id).subscribe(resp => {
      swal('Actividad Borrada',
            'Actividad borrada correctamente. La modificación fue guardada.',
            'success');
      if (!this.congreso.actividades[i].actividad.deleted) {
        // Agrego categoria a las opciones
      this.actividades.push(JSON.parse(JSON.stringify(this.congreso.actividades[i].actividad)));
      }

      // Borro categoria del congreso
      this.congreso.actividades.splice(i, 1);
    });
    } else {
      if (!this.congreso.actividades[i].actividad.deleted) {
        // Agrego categoria a las opciones
      this.actividades.push(JSON.parse(JSON.stringify(this.congreso.actividades[i].actividad)));
      }
      // Borro categoria del congreso
      this.congreso.actividades.splice(i, 1);
    }

  }

  guardarActividad(i: number) {
    this.loading = true;
    if (!this.congreso.actividades[i]._id) {
      this._congresosService.addActividad(this.congreso.actividades[i], this.congreso._id).subscribe(resp => {
        swal('Actividad Agregada',
              'Actividad agregada correctamente. La modificación fue guardada.',
              'success');
              this.loading = false;
      });
    } else {
      // editar
      this._congresosService.editarActividad(
        this.congreso.actividades[i]._id,
        this.congreso.actividades[i].precio,
        this.congreso.actividades[i].precio_usd
      ).subscribe(resp => {
        swal('Actividad Editada',
              'Actividad editada correctamente. La modificación fue guardada.',
              'success');
              this.loading = false;
      });
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/pages/congresos/congresos-edit.component.ts